import $ from 'jquery';
import EFOcats_answer from './efocats_answer.js';

export default class EFOcats_answer_box extends EFOcats_answer {
  /**
   * 選択肢の列数を設定する
   * @param {*} input
   */
  setColumn(elem, input) {
    const name = input.attr('name');
    const type = input.attr('type');

    // 既に設定済みなら処理を進めない
    if (input.parents('.inner').hasClass('singleboxs') || input.parents('.inner').hasClass('doubleboxs')) {
      return;
    }

    if (type === 'radio' || type === 'checkbox') {
      let len = 0;
      let ex = false;
      let yes = false;
      let no = false;

      elem.find(`[name="${name}"]`).each((ind, element) => {
        const text = $(element).parents('.box-label').text().trim();

        if (text.indexOf('時') >= 0) {
          ex = true;
        }

        if (text.length > len) {
          len = text.length;
        }

        if (text === 'はい') {
          yes = true;
        }

        if (text === 'いいえ') {
          no = true;
        }
      });

      const options = elem.find(`[name="${name}"]`).length;

      if (len > 16) {
        // 16文字超過は１列
        input.parents('.inner').addClass('singleboxs');
      } else if (ex) {
        // 「時」を含んでいる選択肢があるので2列
        input.parents('.inner').addClass('doubleboxs');
      } else if (len >= 12) {
        // 12文字超過は1列
        input.parents('.inner').addClass('singleboxs');
      } else if (options >= 4) {
        // 選択肢の数が4つ以上は2列
        input.parents('.inner').addClass('doubleboxs');
      } else if (yes && no && options === 2) {
        // はい、いいえのみなら2列
        input.parents('.inner').addClass('doubleboxs');
      } else {
        // それ以外は1列
        input.parents('.inner').addClass('singleboxs');
      }
    }
  }
}
